import { Tag } from 'antd';
import React from 'react';

const statusToColorMap = {
  BAP: 'volcano',
  INIT: 'geekblue',
  CLOSED: 'blue',
  OPEN: 'green',
};

export type CollectionStatusTagProps = {
  status: string;
  statuslabel:string;
};

const CollectionStatusTag = ({ status,statuslabel }: CollectionStatusTagProps) => {
  const statusUpperCase = status?.toUpperCase();
  //@ts-ignore
  return <Tag color={statusToColorMap[statusUpperCase]}>{statuslabel}</Tag>;
};

export default CollectionStatusTag;
